import { API } from "../backend";

export const SignUp = user => {
  return fetch(`${API}/signup`, {
    method: "POST",
    headers: {
      Accept: "application/json"
    },
    body: user
  })
    .then(response => {
      return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
};

export const SignIn = user => {
 
  return fetch(`${API}/signin`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify(user)
  })
    .then(response => {
      return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
};

export const SignOut = next => {
  let token = null, userId = null;
  if (isAuthenticated()) {
    token = isAuthenticated().token;
    userId = isAuthenticated().user._id;
  }

  if (typeof window !== "undefined") {
    localStorage.removeItem("jwt");
    localStorage.clear();
    next();

    return fetch(`${API}/signout?token=${token}&userId=${userId}`, {
      method: "GET"
    })
      .then(response => console.log("signout success"))
      .catch(err => { console.error(err); return { error: true, message: err?.message }; })
  }
};

export const authenticateUserLogin = (token,userId) =>{
  return fetch(`${API}/authenticate/user-login/${userId}`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Authorization":`Bearer ${token}`
    }
  })
    .then(response => {
      return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

export const authenticate = (data, next) => {
  if (typeof window !== "undefined") {
    localStorage.setItem("jwt", JSON.stringify(data));
    next();
  }
};

export const isAuthenticated = () => {
  if (typeof window == "undefined") {
    return false;
  }
  if (localStorage.getItem("jwt")) {
    return JSON.parse(localStorage.getItem("jwt"));
  } else {
    return false;
  }
};

export const thirdPartySignIn=(user)=>{
  return fetch(`${API}/thrid/party/signin`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify(user)
  })
    .then(response => {
      return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
}
